export function terminalKeyFromUrl(url: string): string | null {
  const match = url.match(/^\/(?:queue|start)\/([^/?#]+)/);
  return match ? decodeURIComponent(match[1]) : null;
}
